var map = {
	"./icon-arrow.svg": "5d09",
	"./icon-audio.svg": "1880",
	"./icon-chevron.svg": "e5a6",
	"./icon-cross.svg": "34f2",
	"./icon-facebook.svg": "431d",
	"./icon-fullscreen-exit.svg": "f973",
	"./icon-fullscreen.svg": "9857",
	"./icon-gallery.svg": "096a",
	"./icon-gyro.svg": "c65d",
	"./icon-hamburger.svg": "823a",
	"./icon-instagram.svg": "8158",
	"./icon-link.svg": "76f3",
	"./icon-linkedin.svg": "4c08",
	"./icon-map-pin.svg": "8499",
	"./icon-pen.svg": "1cd1",
	"./icon-play.svg": "52eb",
	"./icon-post.svg": "da0e",
	"./icon-prospectus.svg": "c1ca",
	"./icon-snapchat.svg": "e072",
	"./icon-tasks.svg": "9f9d",
	"./icon-tour.svg": "f79c",
	"./icon-triangle.svg": "9795",
	"./icon-twitter.svg": "5cfb",
	"./icon-video.svg": "1b5f",
	"./icon-vr.svg": "d5a9",
	"./icon-youtube.svg": "63ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a23c";